import apiClient from '../session/apiClient'

export function getBrandConfigFromHost(hostname) {
  return apiClient.get('/brand/config/' + hostname).then(x => x.data)
}

export function getThemeConfigFromHost(hostname) {
  return apiClient.get('/brand/theme/' + hostname).then(x => x.data)
}

export function getBrandConfig() {
  return apiClient.get('/brand/config').then(x => x.data)
}

export function getThemeConfig() {
  return apiClient.get('/brand/theme').then(x => x.data)
}

export function getDefaultThemeConfig() {
  return apiClient.get('/brand/defaultTheme').then(x => x.data)
}

export function setThemeConfig(themeConfig) {
  return apiClient.post('/brand/theme', themeConfig).then(x => x.data)
}


export async function saveLogo({logo}) {
  const formData = new FormData();
  formData.append("file", logo);
  formData.append("imageType",   "Logo");

  const saveImageResponse = await apiClient.post("/image/upload", formData, { headers: {"Content-Type": 'multipart/form-data'}});
  const imageUrl = saveImageResponse.data
  await apiClient.post("/image/save", { imageUrl, imageType: 'Logo' });
  return imageUrl
}